import { render, staticRenderFns } from "./AsiFadeTransition.vue?vue&type=template&id=36ead52d&scoped=true&"
import script from "./AsiFadeTransition.vue?vue&type=script&lang=ts&"
export * from "./AsiFadeTransition.vue?vue&type=script&lang=ts&"
import style0 from "./AsiFadeTransition.vue?vue&type=style&index=0&id=36ead52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ead52d",
  null
  
)

export default component.exports